module.exports = [
  {
    id: 'GET',
    name: 'GET'
  },
  {
    id: 'POST',
    name: 'POST'
  },
  {
    id: 'PUT',
    name: 'PUT'
  },
  {
    id: 'DELETE',
    name: 'DELETE'
  }
]
